import { Button, Col, Row } from "reactstrap";
import styles from "src/components/Common/UI/MultiStepWizard/MultiStepWizard.module.css";
import { useGetUnit } from "src/pages/Configuration/UnitConfiguration/Units/api/getUnit";

const EstablishmentUnitView = ({
  userID,
  toggleEdit,
  closeWizard,
  interfaceData,
}: EstablishmentNodeViewPros) => {

    const useGetUnitQuery = useGetUnit({unitId: +interfaceData.unitID})

    const unitName = useGetUnitQuery.data?.description

  return (
    <>
    
        <div className={`${styles.stepCard}`}>
          <Row>

            <Col xs="2">
              <label>Μονάδα</label>
            </Col>
            <Col xs="10">
              <p>{interfaceData.unitType}{"-"}{unitName}</p>
            </Col>

  
            <Col xs="12">
              <Button onClick={toggleEdit}>Edit</Button>
            </Col>
            
          </Row>
        </div>
      
    </>
  )
}

export default EstablishmentUnitView;

type EstablishmentNodeViewPros = {
  userID?: number;
  toggleEdit: () => void;
  closeWizard: () => void;
  interfaceData: IEstablishmentInterfaceForm
}